
import { LabellingSamples } from "../entities/labelling-samples.entity";
import { Labelling } from "../entities/labelling.entity";
import { LabellingSamplesDTO } from "./labelling-samples.dto";
import { LabellingData } from "./labelling.dto";

export class LabellingAdapter {
    public convertDtoToEntity(dto: LabellingData): Labelling {
        try {
            const entity = new Labelling;
            entity.saleOrderId = dto.saleOrderId
            entity.saleOrderItemId = dto.saleOrderItemId
            entity.lotNumber = dto.lotNumber
            entity.labellingDate = dto.labellingDate
            entity.traceabilityCode = dto.traceabilityCode
            entity.country = dto.country
            entity.totalMCs = dto.totalMCs
            entity.isActive = dto?.isActive || true;
            if (dto?.labellingId) {
                entity.labellingId = dto.labellingId;
                entity.updatedUser = dto.updatedUser;
            } else {
                entity.createdUser = dto.createdUser;
            }
            const labellingSamplesInfo: LabellingSamples[] = [];

            for (const sampleDto of dto.labellingSamplesInfo) {
                const labellingSample = new LabellingSamples();
                labellingSample.labellingId = dto?.labellingId;
                labellingSample.labellingTime = sampleDto?.time;
               labellingSample.remarks = sampleDto?.remarks;
                labellingSample.correctiveAction = sampleDto?.correctiveAction;
                labellingSample.certificationLogo = sampleDto?.certificationLogo;
                labellingSample.checkedBy = sampleDto?.checkedBy;
                labellingSample.shrimpsLabel = sampleDto?.shrimpsLabel;
                labellingSample.allergenLabel = sampleDto?.allergenLabel;
                if (sampleDto?.labellingSamplesId) {
                    labellingSample.labellingSamplesId = sampleDto.labellingSamplesId;
                    labellingSample.updatedUser = dto.updatedUser;
                } else {
                    labellingSample.createdUser = dto.createdUser;
                }
                labellingSamplesInfo.push(labellingSample);
            }
            entity.labellingSamplesInfo = labellingSamplesInfo;
            console.log(entity);
            return entity;
        } catch (error) {
            return error
        }

    }

    public convertEntityToDto(obj: Labelling): LabellingData {
        const dto = new LabellingData;
        dto.labellingId = obj.labellingId;
        dto.saleOrderId = obj.saleOrderId;
        dto.saleOrderItemId = obj.saleOrderItemId;
        dto.lotNumber = obj.lotNumber;
        dto.labellingDate = obj.labellingDate;
        dto.traceabilityCode = obj.traceabilityCode;
        dto.country = obj.country;
        dto.totalMCs = obj.totalMCs;
        dto.isActive = obj.isActive;
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        return dto;
    }

    public convertEntityToLabelDto(obj: Labelling): LabellingData {
        const dto = new LabellingData;
        dto.labellingId = obj.labellingId;
        dto.saleOrderId = obj.saleOrderId;
        dto.saleOrderItemId = obj.saleOrderItemId;
        dto.lotNumber = obj.lotNumber;
        dto.labellingDate = obj.labellingDate;
        dto.traceabilityCode = obj.traceabilityCode;
        dto.country = obj.country;
        dto.totalMCs = obj.totalMCs;
        dto.isActive = obj.isActive;
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        const labellingSamplesInfo: LabellingSamplesDTO[] = [];
        for (const iterator of obj.labellingSamplesInfo) {
            const labellingSample = new LabellingSamplesDTO();
            labellingSample.labellingId = iterator?.labellingId;
            labellingSample.time = iterator?.labellingTime;
            labellingSample.remarks = iterator?.remarks;
            labellingSample.correctiveAction = iterator?.correctiveAction;
            labellingSample.certificationLogo = iterator?.certificationLogo;
            labellingSample.checkedBy = iterator?.checkedBy;
            labellingSample.shrimpsLabel = iterator?.shrimpsLabel;
            labellingSample.allergenLabel = iterator?.allergenLabel;
            labellingSample.labellingSamplesId = iterator.labellingSamplesId;
            labellingSamplesInfo.push(labellingSample);
        }
        dto.labellingSamplesInfo = labellingSamplesInfo;
        return dto;
    }
}
